import { useTenantApi } from '@/account/hook/useTenantApi';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from './useUserSession';
import { type GroupRegistration, groupRegistrationQueryKey, loadGroupRegistration } from '@/api/registration/groupRegistration';

export function useGroupRegistrationQuery(eventId: string, options: { enabled?: boolean } = { enabled: true }) {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const { userSession } = useUserSession();
  return useQuery<GroupRegistration, Error>({
    queryKey: [groupRegistrationQueryKey, { eventId }, { token: userSession?.authToken }],
    queryFn: async (): Promise<GroupRegistration> => {
      if (userSession?.email === undefined) {
        throw new Error('email is undefined');
      }
      const response = await loadGroupRegistration(createTenantApiRequest)({ email: userSession.email, eventId });
      if (!response.item) {
        throw new Error('No item in response');
      }
      return response.item;
    },
    enabled: !isApiPreparing && options.enabled
  });
}
